import { AssetHeadlineFigure } from "@hydrologiq/gql-experience/graphql"
import Figure from "@hydrologiq/shared/figures/generic/Figure"
import FigureContent from "@hydrologiq/shared/figures/generic/FigureContent"

interface HybridLoadFigureProps {
  data?: AssetHeadlineFigure
  loading?: boolean
  error?: string
  isPlaceholder?: boolean
  compact?: boolean
}

function HybridLoadFigure({
  data,
  loading,
  error,
  isPlaceholder,
  compact = true,
}: HybridLoadFigureProps) {
  const value = data?.value ?? 0
  const unit = data?.unit ?? "kW"

  return (
    <Figure
      heading={data?.label ?? "Current Load"}
      isPlaceholder={!data?.available || error !== undefined || isPlaceholder}
      loading={loading}
      error={error}
      compact={compact}
    >
      <FigureContent.Root compact={compact}>
        <FigureContent.SubText compact={compact}>current</FigureContent.SubText>
        <FigureContent.Value compact={compact}>
          {`${value.toFixed(2)} ${unit}`}
        </FigureContent.Value>
      </FigureContent.Root>
    </Figure>
  )
}

export default HybridLoadFigure
